export default "__VITE_ASSET__mA5zenWH__"